import ClientAgentExtender from '../../../Common/clientAgentExtender'

export default class ZaporeKlicev extends ClientAgentExtender {
  _idPrikljucek = null
  _stevilka = null
  _idSimKartica = null
  _zaporeKlicev = null
  _preusmeritve = null
  _loadingItems = false
  _loadingSave = false

  constructor (idPrikljucek, stevilka, idSimKartica) {
    super()
    this._idPrikljucek = idPrikljucek
    this._stevilka = stevilka
    this._idSimKartica = idSimKartica
  }

  async loadData (override = false) {
    this._loadingItems = true
    if (this._zaporeKlicev === null || override) {
      let response = await this.ca.makeRequest(
        'prikljucek/telefonija/umts/pridobiZaporeKlicev',
        {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka},
        'GET'
      )
      this._zaporeKlicev = response.data.map((item) => {
        item.disabled = false
        item.disabledMessage = ''
        return item
      })
    }
    if (this._preusmeritve === null || override) {
      let response = await this.ca.makeRequest(
        'prikljucek/telefonija/umts/sim/redirects',
        {idSimKartica: this._idSimKartica},
        'GET'
      )
      this._preusmeritve = response.redirects
    }
    this.reloadDisabledAttributes()
    this._loadingItems = false
  }

  reloadDisabledAttributes () {
    this._zaporeKlicev.forEach((zap2) => {
      zap2.disabled = false
      zap2.disabledMessage = ''
    })
    this._preusmeritve.forEach((item) => {
      if (item.active && item.excludedIds != null) {
        this._zaporeKlicev.forEach((zap) => {
          if (item.excludedIds.indexOf(zap.id) !== -1) {
            zap.disabled = true
            zap.disabledMessage = 'Onemogočeno zaradi aktivne preusmeritve "' + item.name + '"'
          }
        })
      }
    })
    this._zaporeKlicev.forEach((zap) => {
      if (zap.active && zap.excludedIds != null) {
        this._zaporeKlicev.forEach((zap2) => {
          if (zap.excludedIds.indexOf(zap2.id) !== -1) {
            zap2.disabled = true
          }
        })
      }
    })
  }

  async save () {
    this._loadingSave = true
    let barrings = []
    let pass = null
    this._zaporeKlicev.forEach((zap) => {
      if (zap.id !== 'password') {
        barrings.push(zap)
      } else {
        pass = zap.value
      }
    })
    let request = {
      idPrikljucek: this._idPrikljucek,
      stevilka: this._stevilka,
      barrings: JSON.stringify(barrings),
      barringPassword: pass
    }
    try {
      await this.ca.makeRequest(
        'prikljucek/telefonija/umts/nastaviZaporeKlicev',
        request,
        'POST'
      )
      await this.loadData(true)
      this._loadingSave = false
    } catch (e) {
      this._loadingSave = false
      throw e
    }
  }

  get zaporeKlicev () {
    return this._zaporeKlicev
  }

  set zaporeKlicev (value) {
    this._zaporeKlicev = value
  }

  get preusmeritve () {
    return this._preusmeritve
  }

  set preusmeritve (value) {
    this._preusmeritve = value
  }

  get loadingItems () {
    return this._loadingItems
  }

  set loadingItems (value) {
    this._loadingItems = value
  }

  get loadingSave () {
    return this._loadingSave
  }

  set loadingSave (value) {
    this._loadingSave = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Prikljucek/Telefonija/Umts/ZaporeKlicev.js